module.exports = __webpack_public_path__ + "images/emoji/clock11.c78029dced5e640690b8.png";